<kPopupWidget #previewEmbed data-aid="previewEmbed" [fullScreen]="true">
  <ng-template>
    <kPreviewEmbedDetails [media]="_media" (closePopup)="close()"></kPreviewEmbedDetails>
  </ng-template>
</kPopupWidget>
